var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.projectId)?_c('div',[_c('h2',{on:{"click":_vm.addItem}},[_vm._v("投资管理功能")]),_c('div',_vm._l((_vm.list),function(item,index){return _c('router-link',{key:index,staticClass:"item",attrs:{"to":item.to}},[_c('el-button',{attrs:{"type":"secondary"}},[_vm._v(_vm._s(item.title))])],1)}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }